import React from 'react';
import { ShoppingBag, X, Minus, Plus, Trash2 } from 'lucide-react';
import { getProductImageUrl } from '../utils/images';

const CartDrawer = ({ isCartOpen, setIsCartOpen, cart, updateCartQuantity, removeFromCart, setView, cartTotal, formatPrice }) => (
  <>
    <div 
      className={`fixed inset-0 z-[110] bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300 ${isCartOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} 
      onClick={() => setIsCartOpen(false)} 
    />
    <div className={`fixed top-0 right-0 z-[120] h-full w-full max-w-md bg-white dark:bg-slate-900 shadow-2xl transition-transform duration-500 transform ${isCartOpen ? 'translate-x-0' : 'translate-x-full'} flex flex-col`}>
      <div className="p-6 border-b dark:border-slate-800 flex justify-between items-center text-slate-900 dark:text-white">
        <h3 className="text-2xl font-black flex items-center gap-3"><ShoppingBag className="text-blue-600" /> Panier</h3>
        <button onClick={() => setIsCartOpen(false)} className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full"><X /></button>
      </div>
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        {cart.length === 0 ? (
          <p className="text-center text-slate-400 py-10 italic">Votre panier est vide</p>
        ) : (
          cart.map(item => (
            <div key={item.cartItemId || item.id} className="flex gap-4 group animate-in fade-in duration-300">
              <img src={getProductImageUrl(item)} className="w-20 h-20 object-cover rounded-2xl bg-slate-100 dark:bg-slate-800" alt={`${item.brand} ${item.label}`.trim() || 'Produit'} />
              <div className="flex-1 min-w-0 text-left">
                <h4 className="font-bold text-sm dark:text-white truncate">{item.label}</h4>
                {item.selectedOptions && (
                  <div className="flex flex-wrap gap-1 mt-1">
                    {Object.entries(item.selectedOptions).map(([key, val]) => (
                      <span key={key} className="text-[9px] bg-slate-100 dark:bg-slate-800 text-slate-500 px-1.5 py-0.5 rounded-md font-bold">
                        {val}
                      </span>
                    ))}
                  </div>
                )}
                <p className="text-blue-600 font-black text-sm mt-1">
                  {formatPrice(item.price)}
                  {item.isFlashSale && (
                    <span className="ml-2 text-[9px] bg-amber-500 text-white px-1.5 py-0.5 rounded-md animate-pulse">FLASH</span>
                  )}
                </p>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => updateCartQuantity(item.cartItemId || item.id, -1)} className="w-7 h-7 bg-slate-100 dark:bg-slate-800 rounded-lg flex items-center justify-center dark:text-white hover:bg-blue-600 transition-colors"><Minus className="w-3 h-3"/></button>
                  <input 
                    type="text" 
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={item.quantity} 
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      if (val !== '') {
                        const numVal = parseInt(val);
                        if (numVal >= 1) {
                          updateCartQuantity(item.cartItemId || item.id, numVal - item.quantity);
                        }
                      }
                    }}
                    onFocus={(e) => e.target.select()}
                    className="w-12 h-7 text-center font-bold bg-slate-100 dark:bg-slate-800 rounded-lg border-none focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                  <button onClick={() => updateCartQuantity(item.cartItemId || item.id, 1)} className="w-7 h-7 bg-slate-100 dark:bg-slate-800 rounded-lg flex items-center justify-center dark:text-white hover:bg-blue-600 transition-colors"><Plus className="w-3 h-3"/></button>
                </div>
              </div>
              <button onClick={() => removeFromCart(item.cartItemId || item.id)} className="text-red-500 self-start p-1"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))
        )}
      </div>
      {cart.length > 0 && (
        <div className="p-6 border-t dark:border-slate-800 space-y-2 bg-slate-50 dark:bg-slate-900/50">
          <div className="flex justify-between font-bold text-sm dark:text-slate-400">
            <span>Total HT</span>
            <span>{formatPrice(cartTotal)}</span>
          </div>
          <div className="flex justify-between font-bold text-sm dark:text-slate-400">
            <span>TVA (20%)</span>
            <span>{formatPrice(cartTotal * 0.2)}</span>
          </div>
          <div className="flex justify-between font-black text-xl dark:text-white pt-2 border-t dark:border-slate-800">
            <span>Total TTC</span>
            <span>{formatPrice(cartTotal * 1.2)}</span>
          </div>
          <button 
            onClick={() => { setIsCartOpen(false); setView('cart'); }} 
            className="w-full bg-blue-600 text-white py-4 mt-4 rounded-2xl font-black shadow-xl hover:bg-blue-700 transition-colors"
          >
            Commander
          </button>
        </div>
      )}
    </div>
  </>
);

export default CartDrawer;
